/**
 * Service layer — "Close Out Project" (2026-08). Marks a project Completed or Cancelled by
 * PATCHing Airtable's `Contract Stage` (the same mechanism services/projectHold.js uses for On
 * Hold). See docs/PROJECT_CLOSEOUT.md. All calls go through the Clerk-authed api/project-closeout.js.
 *
 *   getProjectCloseoutStatus(projectId)         → { closure } — closure is null if not closed out
 *   getProjectCloseoutGateCheck(projectId)       → { openThreads, unpostedMilestones, unpostedTime,
 *                                                    openArCount, openArTotal, openArUnknown }
 *   closeProject(projectId, { status, reason })  → { closure } | { error }
 *   reopenProject(projectId)                     → { closure } | { error }
 *   getClosedProjects()                          → raw Airtable records, Contract Stage in (Completed, Cancelled)
 */

import { apiGetAll } from './_api.js'

const TBL_PROJ = 'tblgWX330MPJkhQVq'

async function authToken() { return window.__clerkGetToken ? await window.__clerkGetToken() : null }

async function closeoutPost(body) {
  const token = await authToken()
  const res = await fetch('/api/project-closeout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}) },
    body: JSON.stringify(body || {}),
  })
  let data = {}; try { data = await res.json() } catch { data = {} }
  if (!res.ok && !data.error) data.error = 'Request failed: ' + res.status
  return data
}
async function closeoutGet(qs) {
  const token = await authToken()
  const res = await fetch('/api/project-closeout?' + qs, { headers: token ? { Authorization: 'Bearer ' + token } : {} })
  let data = {}; try { data = await res.json() } catch { data = {} }
  if (!res.ok && !data.error) data.error = 'Request failed: ' + res.status
  return data
}

export async function getProjectCloseoutStatus(projectId) {
  if (!projectId) return { closure: null }
  return closeoutGet('action=status&projectId=' + encodeURIComponent(projectId))
}
export async function getProjectCloseoutGateCheck(projectId) {
  if (!projectId) return { openThreads: 0, unpostedMilestones: 0, unpostedTime: 0, openArCount: 0, openArTotal: 0, openArUnknown: false }
  return closeoutGet('action=gateCheck&projectId=' + encodeURIComponent(projectId))
}
export function closeProject(projectId, { status, reason } = {}) {
  return closeoutPost({ action: 'close', projectId, status, reason })
}
export function reopenProject(projectId) {
  return closeoutPost({ action: 'reopen', projectId })
}

/**
 * Completed + Cancelled projects — powers the home list's "Show closed projects" filter.
 * apiGetAll paginates properly rather than capping at a fixed maxRecords — see the identical
 * truncation bug this pattern caused for the active-project list (services/projects.js#getOpenProjects).
 */
export function getClosedProjects() {
  const formula = 'OR({Contract Stage}="Completed",{Contract Stage}="Cancelled")'
  return apiGetAll(
    TBL_PROJ,
    'filterByFormula=' + encodeURIComponent(formula) +
    '&sort%5B0%5D%5Bfield%5D=Project+Number&sort%5B0%5D%5Bdirection%5D=asc'
  )
}
